module.exports = __webpack_public_path__ + "img/DAVID_CANNON_42-rs.0a381fba.jpg";